// Intentar cargar un config específico de producción si existe; fallback a auth_config.json
// Nota: En build Angular, ambos archivos se empaquetan si están referenciados. Asegura no exponer secretos.
import baseAuthConfig from "../../auth_config.json";
import prodAuthConfig from "../../auth_config.prod.json";

const config: any =
  prodAuthConfig && (prodAuthConfig as any).domain
    ? prodAuthConfig
    : baseAuthConfig;

// auth_config.json actualmente contiene valores de DESARROLLO (audience localhost).
// Para producción definimos explícitamente el AUDIENCE real de tu API en Auth0.
// IMPORTANTE: Cambia PRODUCTION_AUDIENCE por el API Identifier configurado en Auth0 (Settings > APIs > Identifier).
// Ejemplo típico: https://api.innovadoc-ia.com/innovadocapi
const PRODUCTION_AUDIENCE = "https://api.innovadoc-ia.com/innovadocapi"; // <-- AJUSTA ESTE VALOR

const {
  domain,
  clientId,
  authorizationParams: { audience: rawAudience },
  apiUri,
  errorPath,
} = config as {
  domain: string;
  clientId: string;
  authorizationParams: { audience?: string };
  apiUri: string;
  errorPath: string;
};

// Usar el audience de producción si está definido; si quedó por error 'localhost', lo reemplazamos.
const hasValidProductionAudience = PRODUCTION_AUDIENCE?.startsWith("http");
let effectiveAudience: string | undefined;

if (hasValidProductionAudience) {
  effectiveAudience = PRODUCTION_AUDIENCE;
} else if (rawAudience && !/localhost/i.test(rawAudience)) {
  effectiveAudience = rawAudience;
}

export const environment = {
  production: true,
  homeIaQaHarnessEnabled: false,
  // P1-6 scaffolding flag: Home IA two-zone "attention / follow-up" layout.
  homeAttentionLayout: true,
  apiUrl: "https://api.innovadoc-ia.com/api",
  apiProfilePhotoUrl: "http://photo-profile.innovadoc-ia.com:7451",
  // Home IA API Configuration (production)
  // Home IA base endpoints: /api/home-ia/*
  HOME_API_BASE_URL: "https://api.innovadoc-ia.com/api/home-ia",
  homeIaApiUrl: "https://api.innovadoc-ia.com/api/home-ia",
  homeIaApiTimeoutMs: 30000, // 30s para GET
  homeIaApiMutationTimeoutMs: 60000, // 60s para POST/PATCH
  features: {
    wompiEnabled: true,
  },
  auth: {
    domain,
    clientId,
    authorizationParams: {
      ...(effectiveAudience ? { audience: effectiveAudience } : {}),
      redirect_uri: globalThis.location?.origin ?? '',
      scope: "openid profile email offline_access",
    },
    errorPath,
  },
  auth0: {
    domain,
    clientId,
    authorizationParams: {
      ...(effectiveAudience ? { audience: effectiveAudience } : {}),
      redirect_uri: globalThis.location?.origin ?? '',
      scope: "openid profile email offline_access",
    },
    cacheLocation: 'localstorage' as const,
    useRefreshTokens: true,
    useRefreshTokensFallback: false,
  },
  httpInterceptor: {
    allowedList: [`${apiUri}/*`],
  },
  requestTimeoutMs: 60000,
  // WebSocket base URL for notifications (production)
  wsUrl: 'wss://api.innovadoc-ia.com/api'
};
